import { Api } from "lavva.exalushome";
import { IExalusConnectionService } from "lavva.exalushome/build/js/Services/IExalusConnectionService";
import { ExalusConnectionService } from "lavva.exalushome/build/js/Services/ExalusConnectionService";
import { ILoggerService } from "lavva.exalushome/build/js/Services/Logging/ILoggerService";
import { LoggerService } from "lavva.exalushome/build/js/Services/Logging/LoggerService";
import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { IDevice } from "lavva.exalushome/build/js/Services/Devices/IDevice";
import { IPortos433ConfigService } from "./IPortos433ConfigService";

export class Portos433ConfigService implements IPortos433ConfigService {
    public static readonly ServiceName: string = "Portos433ConfigService";
    private _connection: IExalusConnectionService;
    private _logger: ILoggerService;

    constructor() {
        this._connection = Api.Get<IExalusConnectionService>(ExalusConnectionService.ServiceName);
        this._logger = Api.Get<ILoggerService>(LoggerService.ServiceName);
    }

    GetServiceName(): string {
        return Portos433ConfigService.ServiceName;
    }

    async SendP2PairingSignalAsync(device: IDevice, channel: number): Promise<Status> {
        try {
            if (!device.Channels.any(ch => ch.Number === channel)) {
                this._logger.Error(Portos433ConfigService.ServiceName, `Cannot pair channel. Wrong channel number.`);
                return Status.WrongData;
            }

            const result = await this._connection?.SendAndWaitForResponseAsync(new P2ProgrammingPairRequest(new ChannelPair(device.Guid, channel)), 8000, false);

            if (result == null || result.Status == null) {
                this._logger.Error(Portos433ConfigService.ServiceName, `Cannot pair channel. Controller response does not contain data.`);
                return Status.Error;
            }

            if (result.Status !== Status.OK)
                this._logger.Error(Portos433ConfigService.ServiceName, `Cannot pair channel. Controller responede with status code: ${result.Status}`);
                

            return result.Status;
        } catch (error) {
            this._logger.Error(Portos433ConfigService.ServiceName, `Cannot pair channel. ${error}`);
            return Status.FatalError;
        }
    }
}

class P2ProgrammingPairRequest extends DataFrame<ChannelPair> {
    constructor(data: ChannelPair) {
        super();
        this.Resource = "/portos/devices/device/channel/pair";
        this.Method = Method.Put;
        this.Data = data;
    }
}

class ChannelPair {
    constructor(deviceGuid: string, channel: number) {
        this.DeviceGuid = deviceGuid;
        this.Channel = channel;
    }
    DeviceGuid: string = "";
    Channel: number = 0;
}